import { render, staticRenderFns } from "./news-line.vue?vue&type=template&id=4a5cde4e&scoped=true&"
import script from "./news-line.vue?vue&type=script&lang=js&"
export * from "./news-line.vue?vue&type=script&lang=js&"
import style0 from "./news-line.vue?vue&type=style&index=0&id=4a5cde4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5cde4e",
  null
  
)

export default component.exports